/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { callAxios } from '../services/callAPIMiddleware';
import { queryStringBuilder } from '../utils/helpers';
import globals from '../globals/communityGlobals';

const errorMessages = globals.getArea('error');

const apiModel = (url, method, data, reloadData, mapFunc, callback, errorCallback) => ({
  url,
  method,
  data,
  reloadData,
  mapFunc,
  callback,
  errorCallback,
});

export const apiGetModel = (actionName, params, reloadData, mapFunc, callback) =>
  apiModel(`v1/query/${actionName}${queryStringBuilder(params)}`, 'GET', null, reloadData, mapFunc, callback);

export const apiPostModel = (actionName, data, callback, errorCallback) =>
  apiModel(`v1/command/${actionName}`, 'POST', data, false, null, callback, errorCallback);

export const baseRequestParams = (includeLocation, includeTreatments = false) => ({
  SelectedDate: useSelector(state => state.areas.dailyPlanning.selectedDate),
  IsNightMode: useSelector(state => state.areas.dailyPlanning.scheduler.isNightMode),
  OrgUnitId: useSelector(state => state.areas.dailyPlanning.filters.selectedTeam),
  OrgUnitTeamId: useSelector(state => state.areas.dailyPlanning.filters.orgUnitTeam),
  IncludeLocation: includeLocation,
  IncludeTreatments: includeTreatments,
});

export const useApi = model => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [response, setResponse] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (jwtToken) {
      const usingCallback = model.callback && typeof model.callback === 'function';
      callAxios(auth, model.url, model.method, model.data)
        .then(result => {
          if (usingCallback) {
            model.callback(result, false, null);
          } else {
            setResponse({ result });
            setIsDataLoading(false);
          }
        })
        .catch(ex => {
          model.callback(null, false, ex.message);
          setError(ex.mesage);
        });
    }
  }, [jwtToken, model.reloadData]);

  return { response, isDataLoading, error };
};

export const postApi = (auth, model) => {
  const usingCallback = model.callback && typeof model.callback === 'function';
  const usingErrorCallback = model.errorCallback && typeof model.errorCallback === 'function';

  const errorMessage = (msg, params = []) => {
    return errorMessages.getMsg(msg).includes('Missing text') ? msg : errorMessages.getMsg(msg, params);
  };

  callAxios(auth, model.url, model.method, model.data)
    .then(result => {
      if (usingCallback) {
        model.callback(result, null);
      }
    })
    .catch(ex => {
      if (usingErrorCallback) {
        const keys = Object.keys(ex.response.data);
        const message = errorMessage(ex.response.data.translationKey, ex.response.data.parameters);

        model.errorCallback({
          props: keys,
          message,
        });
      } else {
        // eslint-disable-next-line no-alert
        alert(`${errorMessage(ex.response.data.translationKey, ex.response.data.parameters)} `);
      }
    });
};

export const getApi = (auth, model) => {
  const usingCallback = model.callback && typeof model.callback === 'function';
  const usingMapFunc = model.mapFunc && typeof model.mapFunc === 'function';

  callAxios(auth, model.url, model.method, model.data)
    .then(response => {
      const result = response ? (usingMapFunc ? model.mapFunc(response.data) : response.data) : {};
      if (usingCallback) {
        model.callback(result);
      } else {
        return result;
      }
    })
    .catch(ex => {
      model.callback(null, ex.message);
    });
};
